// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Засідання комітету» (Committee meetings, ключ `cmeeting`, група `committees`). */
export const committeeMeetingsManifest: IModuleManifest = {
  key: 'cmeeting',
  group: 'committees',
  slug: 'committee-meetings',
  prefix: 'CMT',
  name: { en: 'Committee meetings', uk: 'Засідання комітету' },
  entities: [
    { key: 'cmeeting', slug: 'cmeeting', name: { en: 'Committee meetings', uk: 'Засідання комітету' }, main: true },
    { key: 'cvt', slug: 'cvt', name: { en: 'Committee Voting', uk: 'Голосування в комітеті' }, main: false },
    { key: 'meeting_agenda_item', slug: 'meeting-agenda-item', name: { en: 'Meeting Agenda Items', uk: 'Пункти порядку денного' }, main: false },
    { key: 'meeting_participant', slug: 'meeting-participant', name: { en: 'Meeting Participants', uk: 'Учасники' }, main: false },
    { key: 'meeting_decision', slug: 'meeting-decision', name: { en: 'Meeting Decisions', uk: 'Рішення' }, main: false },
    { key: 'meeting_minutes', slug: 'meeting-minutes', name: { en: 'Meeting Minutes', uk: 'Протокол засідання' }, main: false },
    { key: 'meeting_status', slug: 'meeting-status', name: { en: 'Meeting Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/committeeMeetingsSlice').then((m) => m.committeeMeetingsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
